// Favicon utility functions for runtime favicon switching

export type ProjectTheme = 'cms' | 'rms';

// Map project theme to favicon file
const faviconMap: Record<ProjectTheme, string> = {
  cms: 'favicon.ico',
  rms: 'favicon2.ico',
};

/**
 * Update the favicon dynamically at runtime
 */
export const updateFavicon = (theme: ProjectTheme): void => {
  if (typeof document === 'undefined') return;
  
  const faviconName = faviconMap[theme];
  if (!faviconName) {
    console.warn(`⚠️  No favicon mapping found for theme: ${theme}`);
    return;
  }
  
  // Find existing favicon link or create a new one
  let faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(faviconLink);
  }
  
  // Update favicon source
  // Use relative path since favicons are in public directory
  faviconLink.href = `/${faviconName}`;
  
  // Also update apple-touch-icon if it exists
  let appleTouchIcon = document.querySelector("link[rel~='apple-touch-icon']") as HTMLLinkElement;
  if (appleTouchIcon) {
    // You can add apple-touch-icon mapping here if needed
    // appleTouchIcon.href = `${publicUrl}/logo192.png`;
  }
};

/**
 * Initialize favicon based on project theme
 */
export const initFavicon = (theme: ProjectTheme): void => {
  updateFavicon(theme);
};

